<template>
    <div class="app__container" :class="[ !hasSidebar ? 'no-sidebar' : '' ]">
        <header :style="{ 'border-top-color' : headerColor }">
            <div class="header__logo" :style="{ 'background-color' : headerColor, 'border-color' : headerColor, width : sidebarWidth + 'px' }">
                <slot name="logo">
                    <svg viewBox="0 0 68 18" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414">
                        <g fill="#fff" fill-rule="nonzero">
                            <path d="M25.855 8.35V8.6c-.012.703-.258.965-.91.965H23.93V7.3h1.024c.57 0 .9.172.9 1.05zm1.247.116v-.19c0-1.345-.72-2-2.204-2h-1.845c-.18 0-.325.146-.325.325v6.12c0 .084.047.1.134.1h.926c.087 0 .14-.007.142-.1v-2.153h1.08c1.39 0 2.075-.687 2.092-2.1zm4.837-1.48V6.6c0-.178-.147-.324-.326-.324h-3.08c-.178 0-.324.146-.324.325v6.12c0 .09.064.1.21.1h3.262c.126 0 .19-.016.19-.1v-.618c0-.18-.145-.325-.324-.325H29.41V9.91h1.548c.18 0 .325-.145.325-.324V9.22c0-.178-.145-.324-.325-.324H29.41V7.31h2.204c.18 0 .325-.146.325-.325zm4 3.276h-1.333l.287-1.06c.048-.172.092-.327.13-.468l.01-.032c.094-.332.168-.595.224-.832l.035-.148.034.148c.05.21.11.446.19.745.046.17.097.364.154.586l.27 1.062zm1.907 2.524c.015-.02.017-.044.008-.075l-1.817-6.123c-.04-.18-.208-.31-.4-.31h-.617c-.19 0-.356.124-.406.303l-1.876 6.07c-.012.038-.025.09.002.128.03.04.083.042.168.042h.74c.185 0 .26-.004.288-.1l.41-1.5h1.837l.383 1.512c.025.084.085.088.208.088h.946v.035-.035c.048 0 .102 0 .127-.034zm5.643-.007c.02-.038-.004-.086-.025-.118L41.36 9.108l1.69-2.532c.043-.058.05-.133.018-.195-.033-.063-.1-.104-.175-.104h-.636c-.19 0-.37.1-.47.26L40.08 9.04V6.6c0-.178-.145-.324-.324-.324h-.552c-.18 0-.324.146-.324.325v6.12c0 .084.056.1.166.1h.857c.127 0 .175-.01.175-.1V9.125l2.05 3.557c.096.134.15.14.257.14h.973c.064 0 .11-.003.132-.04zm7.25-6.182c.014-.077-.006-.158-.058-.22-.053-.065-.13-.102-.21-.102h-.553c-.18 0-.348.136-.38.31L49.1 9.01c-.127.708-.22 1.475-.266 1.868l-.034.302-.036-.3c-.054-.45-.143-1.11-.26-1.713l-.525-2.58c-.032-.178-.195-.31-.38-.31h-.516c-.185 0-.35.132-.38.307l-.514 2.574c-.114.58-.21 1.17-.282 1.746l-.04.31-.03-.31c-.074-.718-.16-1.326-.263-1.858l-.468-2.46c-.03-.177-.194-.31-.38-.31h-.608c-.083 0-.16.037-.212.1-.052.064-.073.145-.057.223l1.264 6.13c.02.084.087.09.192.09h.982c.094 0 .15 0 .18-.112l.594-2.9c.078-.39.18-1.168.208-1.397l.037-.287.034.288c.044.365.116.907.216 1.426l.576 2.896c.02.08.073.088.143.088h1.022c.08 0 .145-.007.17-.095l1.272-6.127zm4.554 2.96c0 1.777-.32 2.407-1.22 2.407-.894 0-1.227-.66-1.227-2.436 0-1.742.333-2.39 1.228-2.39.89 0 1.22.656 1.22 2.417zm1.295-.02c0-2.245-.847-3.383-2.515-3.383-1.674 0-2.523 1.148-2.523 3.412 0 2.27.828 3.374 2.533 3.374 1.685 0 2.504-1.112 2.504-3.4zm4.105-1.356c0 .725-.244.995-.9.995h-.76V7.3h.75c.664 0 .91.24.91.882zm1.435 4.61c.017-.026 0-.07-.006-.09-.005-.014-.492-1.472-.685-2.063-.142-.434-.45-.618-.55-.678-.03-.018-.04-.023-.045-.037l-.015-.036.038-.012c.72-.22 1.085-.808 1.085-1.743 0-1.233-.733-1.86-2.177-1.86h-1.62c-.18 0-.323.215-.323.392v6.053c0 .092.053.1.128.1h.943c.085 0 .13-.004.133-.1l-.002-2.538h.442c.218 0 .517 0 .714.473.185.445.683 2.068.688 2.084.033.073.063.08.146.08h1.006c.052 0 .087-.01.1-.03zm5.757-.13L65.78 9.108l1.693-2.532c.043-.058.05-.133.017-.195-.033-.063-.1-.104-.175-.104h-.636c-.19 0-.37.1-.47.26L64.503 9.04V6.6c0-.178-.145-.324-.324-.324h-.552c-.178 0-.324.146-.324.325v6.12c0 .084.056.1.167.1h.855c.127 0 .175-.01.175-.1l.002-3.596 2.05 3.557c.094.134.15.14.255.14h.973c.064 0 .11-.003.132-.04.02-.038-.004-.086-.025-.118zM.8 10.702L11.113 5.16 4.157.197.8 10.702zm9.932 6.876l-.13-11.228L.88 11.04l9.852 6.538zM13.02 5.346l.966-4.16c-.377-.06-2.06-.318-4.52-.63C7.314.283 5.22.08 4.377 0l8.644 5.346zm4.866 4.955c-.492-1.19-3.313-8.027-3.68-8.922l-.814 6.587 4.494 2.336zm-6.854 7.342l6.855-7.03-6.54-2.492-.315 9.522zm-.647.09l-9.64-6.413c.615 1.015 2.938 4.823 2.938 4.823l6.702 1.588zM0 6.786s.396 3.1.5 3.89L3.882.056 0 6.787z"/>
                        </g>
                    </svg>
                </slot>
            </div>

            <div class="header__group">
                <div v-if="hasLeftHeader || title" class="header__item header__item--left">
                    <slot name="headerLeft">
                        <h1>{{ title }}</h1>
                    </slot>
                </div>
                <div v-if="hasRightHeader" class="header__item header__item--right">
                    <slot name="headerRight"></slot>
                </div>
            </div>

        </header>

        <aside v-if="hasSidebar" :style="{ width : sidebarWidth + 'px'}">
            <slot name="sidebar"></slot>
        </aside>

        <main>
            <slot></slot>
        </main>
    </div>
</template>

<script>
    export default {
        name: 'pw-layout',
        props: {
            headerColor: {
                type: String
            },
            sidebarWidth: {
                type: Number,
                default: 180
            },
            title: {
                type: String
            }
        },
        computed: {
            hasLeftHeader() {
                return !!this.$slots['headerLeft'];
            },
            hasRightHeader() {
                return !!this.$slots['headerRight'];
            },
            hasSidebar() {
                return !!this.$slots['sidebar'];
            }
        }
    };
</script>

<style lang="scss" scoped>
    $accent-color: #009cd2;
    $border-color: #d5d9d9;

    @supports not (display: grid) {
        .app__container {
            display: flex;
            flex-wrap: wrap;
        }

        .header {
            display: flex;            
        }

        .header__logo {
            flex: 0 1 auto;
        }

        aside {
            min-height: calc(100vh - 54px);
        }

        main {
            flex: 1 0 auto;
        }
    }

    @supports (display: grid) {
        .app__container {
            display: grid;
            grid-template-columns: 180px 1fr;
            grid-template-rows: 54px 1fr;
            height: 100%;
        }

        header {
            display: grid;
            grid-area: 1 / 1 / 2 / -1;
            grid-template-columns: 180px 1fr;
        }

        .no-sidebar main {
            grid-column: 1 / -1;
        }
    }
  
    header {
        border-bottom: 1px solid $border-color;
        border-bottom: 1px solid var(--pewter-lighten-6, $border-color);
        border-top: 6px solid $accent-color;
        border-top: 6px solid var(--cerulean, $accent-color);
    }

    .header__logo {
        background-color: $accent-color;
        background-color: var(--cerulean, $accent-color);
        border-right: 1px solid $accent-color;
        border-right: 1px solid var(--cerulean, $accent-color);
        height: 47px;
        padding: 3px 0.5rem 6px;
    }

    .header__logo > * {
        display: inline-block;
        max-height: 100%;
        max-width: 100%;
    }

    .header__group {
        align-items: center;
        background-color: #fff;
        display: flex;
        flex: 1 0 auto;
        padding: 0.5rem 1rem;
    }

    .header__item--right {
        margin-left: auto;
    }

    header h1 {
        color: $accent-color;
        font-size: 1.5rem;
        margin: 0;
    }

    aside {
        background-color: #fff;
        border-right: 1px solid $border-color;
        border-right: 1px solid var(--pewter-lighten-4, $border-color);
    }

    main {
        padding: 1rem;
    }
</style>
